var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckmarkSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.41663 19.1663L24 3.39967L21.4333 0.833008L8.41663 13.6663L2.91663 8.16634L0.166626 10.9163L8.41663 19.1663Z",
    fill: "#1966FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkSmall);
export default __webpack_public_path__ + "static/media/checkmark-small.90481e417a2d60e12d77764d6991ffab.svg";
export { ForwardRef as ReactComponent };